import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {orderCodActions} from "./orderCodSlice";
import {codApi} from "~/api";

function* fetchDemoList(action) {
	try {
		const response = yield call(codApi.getsOrder, action.payload);
		yield put(orderCodActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch order list', error);
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(orderCodActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action) {
	yield put(orderCodActions.setFilter(action.payload));
}

export default function* orderCodSaga() {
	yield takeLatest(orderCodActions.fetchData.type, fetchDemoList);
	yield debounce(500, orderCodActions.setFilterWithDebounce.type, handleSearchDebounce)
}